import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { TruckForm } from "@/features/dashboard/caminhoes/components/TruckForm";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/marcas/cadastrar/modal")({
  component: () => (
    <BaseEditCreateModal title="Criar nova Marca de Caminhão" from="/dashboard/caminhoes/marcas/cadastrar">
      <TruckForm />
    </BaseEditCreateModal>
  )
});
